import type { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';

import { CISecondaryButton } from 'common/viewcomp/forms/buttons';

import '../patientForgotUserId.scss';

interface PatientForgotUserIdViewProps {
    onBackToLogin: () => void;
    className?: string;
}

export const PatientForgotUserIdView = ({
    onBackToLogin,
    className = '',
}: PatientForgotUserIdViewProps): ReactElement => {
    const { t } = useTranslation('auth');

    return (
        <div className={`patient_forgot_user_id ${className}`}>
            <div className="patient_forgot_user_id_text">{t('patient_forgot_id.header')}</div>
            <CISecondaryButton
                id="backToLoginPatientForgotID"
                className="patient_forgot_user_id_back_login"
                onClick={onBackToLogin}
            >
                {t('patient_forgot_id.back_to_login')}
            </CISecondaryButton>
        </div>
    );
};
